<template>
  <div class="overlay-blue-screen">
    <div class="init-list">
      <i :class="completedText.icon"></i>
      <h1> Welcome to Quasiris Search Cloud  <i class="fa-brands fa-searchengin"></i></h1>
      <h1>{{completedText.text}}</h1>
      <p>{{completedText.p}}</p>
      <div class="d-flex justify-content-center" v-if="status">
         <div class="loader"></div> 
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";

const props = defineProps({
  status: Boolean,
});
const completedText = reactive({ text: 'Search App Started!', p: 'Your search data is being processed', icon: 'fa fa-rocket fa-6x' })
</script>

<style scoped>
.overlay-blue-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9888;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.init-list {
  text-align: center;
}

.loader {
  width: 120px;
  height: 20px;
  -webkit-mask: linear-gradient(90deg,#000 70%,#0000 0) left/20% 100%;
  background: linear-gradient(#000 0 0) left -25% top 0 /20% 100% no-repeat #ddd;
  animation: l7 1s infinite steps(6);
}

@keyframes l7 {
  100% {background-position: right -25% top 0}
}
</style>
